import $ from 'jquery';

export function amInit() {
  
  // Link email addresses
  $('.p3').each(function() {
    if ($(this).text().indexOf('@') > -1) {
      var line = $(this).text().split(' ');
      line[0] = '<a href="mailto:' + line[0] + '">' + line[0] + '</a>';
      $(this).html(line.join(' '));
    }
  });
	
	// Build the calendars
	var days_of_the_week = [
		{ full: 'Sunday', short: 'Sun' },
		{ full: 'Monday', short: 'Mon' },
		{ full: 'Tuesday', short: 'Tue' },
		{ full: 'Wednesday', short: 'Wed' },
		{ full: 'Thursday', short: 'Thu' },
		{ full: 'Friday', short: 'Fri' },
		{ full: 'Saturday', short: 'Sat' },
	];
	
	var months_of_the_year = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	$('#calendar').find('table').each(function() {
		var started = false;
		var day = 1;
		var dow = 0;
		
		$(this).find('td').each(function() {
			$(this).attr('data-full', days_of_the_week[dow].full);
			$(this).attr('data-short', days_of_the_week[dow].short);
			if (dow < 6) {
				dow++;
			} else {
				dow = 0;
			}
			
			if ($(this).hasClass('start')) {
				started = true;
			}
			if (started) {
				$(this).html('<div>' + day + '</div>').attr('data-day', day);
				day++;
			}
			if ($(this).hasClass('stop')) {
				started = false;	
			}
		});
	});
	
	// Place the events
	$.each(events, function(index, event) {
		var cell = $('#calendar').find('table[data-month="' + this.month + '"][data-year="' + this.year + '"]').find('[data-day="' + this.day + '"]');
		var list = cell.data('events');
		if (list) {
			list = list + ',' + index;
		} else {
			list = index;	
		}
		cell.attr('data-events', list);
		var div = cell.find('div');
		div.addClass('has-events').addClass('selectable');
		
		$.each(this.categories, function() {
			div.addClass(this);
		});
	});
		
	// Next and Previous Months
	$('.fa-chevron-left').click(function() {
		if (!$(this).hasClass('disabled')) {
			var current_month = $('#calendar').find('table:visible');
			var month_to_show = parseInt(current_month.attr('data-month')) - 1;
			var year_to_show = parseInt(current_month.attr('data-year'));
			if (month_to_show == 0) {
				month_to_show = 12;
				year_to_show = year_to_show - 1;
			}			
			
			current_month.hide();
			$('#calendar').find('table[data-year="' + year_to_show + '"][data-month="' + month_to_show + '"]').show();
			$('#selected_month').text(months_of_the_year[month_to_show]);
			$('#selected_year').text(year_to_show);
			checkArrows();
		}
	});
	
	$('.fa-chevron-right').click(function() {
		if (!$(this).hasClass('disabled')) {
			var current_month = $('#calendar').find('table:visible');
			var month_to_show = parseInt(current_month.attr('data-month')) + 1;
			var year_to_show = parseInt(current_month.attr('data-year'));
			if (month_to_show == 13) {
				month_to_show = 1;
				year_to_show = year_to_show + 1;
			}		
			
			current_month.hide();
			$('#calendar').find('table[data-year="' + year_to_show + '"][data-month="' + month_to_show + '"]').show();
			$('#selected_month').text(months_of_the_year[month_to_show]);
			$('#selected_year').text(year_to_show);
			checkArrows();
		}
	});
	
	// Show events on click
	$('#calendar').on('click', '.selectable', function() {
		var cell = $(this).parent();
		var list = cell.attr('data-events');
		var day_full = cell.attr('data-full');
		var day_short = cell.attr('data-short');
		var day_number = cell.attr('data-day');
		
		list = list.split(',');
		
		$('.selected').removeClass('selected');
		$(this).addClass('selected');
		
		var html = `<div class="date">
	<h2 class="white">${day_number}</h2>
	<h4 class="white small hidden-md hidden-sm hidden-xs">${day_full}</h4>
	<h4 class="white small caps hidden-lg">${day_short}</h4>
	<div class="clearfix"></div>
</div>`;
		
		var i = 0;
		
		// Filtering
		var disciplines = [];
		$('#discipline_items').find('.checked').parent().each(function() {
			disciplines.push($(this).data('category'));
		});
		var event_types = [];
		$('#event_items').find('.checked').parent().each(function() {
			event_types.push($(this).data('category'));
		});
		
		$.each(list, function(index, value) {
			var event = events[value];			
			var disc_match = false;
			var type_match = false;
						
			$.each(disciplines, function() {
				if ($.inArray(this, event.categories) > -1) {
					disc_match = true;
					return false;
				}
			});
			$.each(event_types, function() {
				if ($.inArray(this, event.categories) > -1) {
					type_match = true;
					return false;
				}
			});
			
			if (disc_match && type_match) {
				i++;
				html += `<div class="info">
	<h5 class="white">${event.title}</h5>
	<p>Time: ${event.time}</p>`;
				if (event.location != '') {
					html += `<p>Location: ${event.location}</p>`;
				}
				if (event.details != '') {
					html += `<p>${event.details}</p>`;
				}
				html += `</div>`;
			}
		});
		
		if (i == 0) {
			html += `<div class="info">
	<h5 class="white">No events are scheduled today.</h5>
</div>`;
		}

		$('.details').html(html);
	});
		
	// Filters
	$('#discipline_items').html($('#discipline_items_temp').html());
	$('#event_items').html($('#event_items_temp').html());
	$('#discipline_items > li, #event_items > li').click(function() {
		$(this).find('.check').toggleClass('checked');
		if ($(this).find('.check').hasClass('all') && $(this).find('.check').hasClass('checked')) {
			$(this).parent().find('.check').removeClass('checked');	
			$(this).find('.check').addClass('checked');
		} else {
			var all = true;
			var i = 0;
			$(this).parent().find('.check').each(function() {
				if (i > 0) {
					if ($(this).hasClass('checked')) {
						all = false;	
					}
				}
				i++;
			});

			if (all) {
				$(this).parent().find('.check').eq(0).addClass('checked');
			} else {
				$(this).parent().find('.check').eq(0).removeClass('checked');
			}
		}
		
		// Logic time
		$('.selected').trigger('click');
		
		var disciplines = [];
		$('#discipline_items').find('.checked').parent().each(function() {
			disciplines.push($(this).data('category'));
		});
		var event_types = [];
		$('#event_items').find('.checked').parent().each(function() {
			event_types.push($(this).data('category'));
		});
		
		$('#calendar').find('.has-events').removeClass('selectable').each(function() {
			var div = $(this);
			var disc_match = false;
			var type_match = false;
			
			$.each(disciplines, function() {
				if (div.hasClass(this)) {
					disc_match = true;
					return false;
				}
			});
			$.each(event_types, function() {
				if (div.hasClass(this)) {
					type_match = true;
					return false;
				}
			});
			
			if (disc_match && type_match) {
				div.addClass('selectable');	
			}
		});
		
		// Yes, again
		$('.selected').trigger('click');
		
	});
	
	// Auto-select today
	var date = new Date();
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	$('#selected_month').text(months_of_the_year[month]);
	$('#selected_year').text(year);
	var table = $('#calendar').find('table[data-year="' + year + '"][data-month="' + month + '"]');
	table.show();
	table.find('[data-day="' + day + '"]').find('div').addClass('selected').trigger('click');
	
	// Check the arrows
	function checkArrows() {
		$('.fa-chevron-left').removeClass('disabled');
		$('.fa-chevron-right').removeClass('disabled');
		
		var current_month = parseInt($('#calendar').find('table:visible').attr('data-month'));
		var current_year = parseInt($('#calendar').find('table:visible').attr('data-year'));
		if (current_month == 1 && current_year == 2019) {
			$('.fa-chevron-left').addClass('disabled');
		} else if (current_month == 12 && current_year == 2020) {
			$('.fa-chevron-right').addClass('disabled');
		}
	}
	checkArrows();
  
  // Second stage shows
  
  $('.tile').click(function() {
		$('.disc-details').find('.background').css('background-image', $(this).find('.background').css('background-image'));
		$('#disc_title').text($(this).find('h4').text() + ' Shows');
		$('.disc-details').show();
		setTimeout(function() {
			$('.disc-details').removeClass('fade');
		}, 1);
		$('#disc_loader').show().removeClass('fade');
		
		var category_id = $(this).data('category_id');
		$.get('/ajax/second_stage/' + category_id, function(response) {
			$('#disc_loader').addClass('fade');
			setTimeout(function() {
				$('#disc_loader').hide();
			}, 500);
			
			$('#disc_details').html(response).removeClass('fade');
      
      $('#disc_details .show-time').click(function() {
        $('#disc_details .show-time').removeClass('active');
        $(this).addClass('active');
        $('.show-title').text($(this).data('title'));
        $('.show-date').text($(this).data('date'));
        $('.show-location').text($(this).data('location'));
        $('.show-description').html($(this).data('description'));
      });
      
		});
	});
	
	$('.disc-details').on('click', '.close-button, h5', function() {
		$('.disc-details').addClass('fade');
		setTimeout(function() {
			$('.disc-details').hide();
			$('#disc_details').html('').addClass('fade');
			$('.video').find('iframe').attr('src', false);
		}, 500);
	});
}